import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../../src/assets/images/logo/iknowa-logo-v4.svg'
import _imports_1 from '../../../../assets/icons/trash-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-6a7b9d82"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "previous_btn isShowLimitedCompanyWorkStation" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = { class: "custom__modal__header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "open-logo",
  src: _imports_0
}, null, -1))
const _hoisted_5 = { class: "custom__modal__content" }
const _hoisted_6 = { class: "custom__modal__heading" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "description" }
const _hoisted_9 = {
  key: 0,
  class: "modal__inner__body"
}
const _hoisted_10 = { class: "custom__modal__sub__content" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Nickname", -1))
const _hoisted_12 = { class: "uploade-wrapper solo-trader-uploade-wrapper" }
const _hoisted_13 = { class: "uploade-wrapper" }
const _hoisted_14 = { class: "custom__modal__body" }
const _hoisted_15 = {
  key: 0,
  class: "modal__inner__body address_modal"
}
const _hoisted_16 = {
  key: 0,
  class: "selected__address"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Your Address", -1))
const _hoisted_18 = { class: "user_Address" }
const _hoisted_19 = { class: "edit_postcode" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_21 = {
  key: 1,
  class: "postcode__wrapper"
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "input__file" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Address line", -1))
const _hoisted_25 = { class: "input__file" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "City / Town", -1))
const _hoisted_27 = { class: "input__file" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Postcode", -1))
const _hoisted_29 = {
  key: 0,
  class: "address__postcodes"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  key: 1,
  class: "error_msg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_stepper_item = _resolveComponent("v-stepper-item")!
  const _component_v_stepper_header = _resolveComponent("v-stepper-header")!
  const _component_v_stepper = _resolveComponent("v-stepper")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: $setup.isShowHomeownersWorkStation,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.isShowHomeownersWorkStation) = $event)),
    width: "968px",
    class: "custom__modal__box homeowner__modal__box",
    persistent: "",
    height: "auto"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_btn, {
          variant: "text",
          "aria-label": "Refresh",
          class: "back_btn",
          "prepend-icon": "mdi-chevron-left",
          onClick: $setup.onClickBackButton
        }, {
          default: _withCtx(() => [
            _createTextVNode("back")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("main", _hoisted_2, [
        _createElementVNode("header", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("h4", null, _toDisplayString($setup.currentSelectedTab.header), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h3", _hoisted_7, _toDisplayString($setup.currentSelectedTab.title), 1),
            _createElementVNode("p", _hoisted_8, _toDisplayString($setup.currentSelectedTab.description), 1)
          ]),
          ($setup.currentSelectedTab.name === 'Profile Picture & Name')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(_component_v_text_field, {
                    density: "compact",
                    placeholder: "E.g. Klein Buildings",
                    modelValue: $setup.tradingName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.tradingName) = $event)),
                    variant: "outlined",
                    class: "c-input rounded-full"
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_v_file_input, {
                        class: _normalizeClass(["upload_file", { 'added-img': $setup.imageUrl }]),
                        label: "Upload",
                        "append-inner-icon": "mdi-image-plus",
                        variant: "solo-filled",
                        onChange: $setup.onFileChange,
                        "onClick:clear": $setup.clearImageUrl
                      }, null, 8, ["onChange", "onClick:clear", "class"]),
                      _createVNode(_component_v_img, {
                        class: "uploaded-img",
                        width: 200,
                        "aspect-ratio": "16/9",
                        cover: "",
                        src: $setup.imageUrl
                      }, null, 8, ["src"])
                    ])
                  ])
                ]),
                _createVNode(_component_v_btn, {
                  class: "button button-lightGray w-full",
                  onClick: $setup.onClickContinue,
                  loading: $setup.isLoadingAddressData ? true : false
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Continue")
                  ]),
                  _: 1
                }, 8, ["onClick", "loading"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_14, [
            ($setup.currentSelectedTab.name === 'Address')
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  (!$setup.isShowNewAddresslist)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _hoisted_17,
                        _createElementVNode("p", _hoisted_18, _toDisplayString($setup.user.address), 1),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("span", null, _toDisplayString($setup.user.postcode), 1),
                          _createVNode(_component_v_btn, {
                            class: "button",
                            onClick: $setup.onClickAddAnotherAddress
                          }, {
                            default: _withCtx(() => [
                              _hoisted_20
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _createVNode(_component_v_btn, {
                          class: "button button-purple-border",
                          onClick: $setup.onClickAddAnotherAddress
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Choose another address")
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_v_btn, {
                          class: "button button-orange",
                          onClick: $setup.onConfirmAddress
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Confirm")
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createVNode(_component_v_form, {
                          ref: "postcodeform",
                          rules: $setup.rules,
                          onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
                        }, {
                          default: _withCtx(() => [
                            ($setup.isShowAddressData)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                  _createElementVNode("div", _hoisted_23, [
                                    _hoisted_24,
                                    _createVNode(_component_v_text_field, {
                                      density: "compact",
                                      variant: "outlined",
                                      class: "c-input rounded-full",
                                      modelValue: $setup.address,
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.address) = $event)),
                                      disabled: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _createElementVNode("div", _hoisted_25, [
                                    _hoisted_26,
                                    _createVNode(_component_v_text_field, {
                                      density: "compact",
                                      variant: "outlined",
                                      class: "c-input rounded-full",
                                      modelValue: $setup.place,
                                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.place) = $event)),
                                      disabled: ""
                                    }, null, 8, ["modelValue"])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_27, [
                              _hoisted_28,
                              _createVNode(_component_v_text_field, {
                                density: "compact",
                                placeholder: "e.g E1 1BA",
                                variant: "outlined",
                                class: "c-input rounded-full",
                                modelValue: $setup.postCode,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.postCode) = $event)),
                                rules: $setup.rules.postCode,
                                disabled: $setup.isShowAddressData ? true : false
                              }, null, 8, ["modelValue", "rules", "disabled"]),
                              ($setup.addressListfromPostcode.length && !$setup.isShowAddressData)
                                ? (_openBlock(), _createElementBlock("ul", _hoisted_29, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.addressListfromPostcode, ({ DPA }) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        key: DPA?.UPRN,
                                        onClick: ($event: any) => ($setup.handleSelectAddress(DPA))
                                      }, [
                                        _createElementVNode("div", null, _toDisplayString(DPA?.ADDRESS), 1)
                                      ], 8, _hoisted_30))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            ($setup.errorMessagePostcode)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString($setup.errorMessagePostcode), 1))
                              : _createCommentVNode("", true),
                            (!$setup.isShowAddressData)
                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                  key: 2,
                                  class: _normalizeClass(["button disabled", { 'button-orange': $setup.isDisabledNextButton }]),
                                  size: "large",
                                  block: "",
                                  loading: $setup.isActiveNextButton,
                                  disabled: !$setup.isDisabledNextButton,
                                  onClick: $setup.GoToFindAddress
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" find address ")
                                  ]),
                                  _: 1
                                }, 8, ["class", "loading", "disabled", "onClick"]))
                              : _createCommentVNode("", true),
                            ($setup.isShowAddressData)
                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                  key: 3,
                                  class: _normalizeClass(["button disabled", { 'button-orange': $setup.isDisabledNextButton }]),
                                  size: "large",
                                  block: "",
                                  disabled: !$setup.isDisabledNextButton,
                                  onClick: $setup.onClickContine
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" CONTINUE ")
                                  ]),
                                  _: 1
                                }, 8, ["class", "disabled", "onClick"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["rules"])
                      ]))
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_v_stepper, {
              class: "onboard-stepper",
              modelValue: $setup.currentSelectedTab.name,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.currentSelectedTab.name) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_stepper_header, { class: "onboard-stepper__header" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tabListItems, (step, index) => {
                      return (_openBlock(), _createBlock(_component_v_stepper_item, {
                        class: "onboard-stepper__item",
                        key: index,
                        title: step.tab,
                        value: step.name
                      }, null, 8, ["title", "value"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}